import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { DATE_FORMAT } from 'src/app/shared/constants/input.constants';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IClientCertificate } from 'src/app/shared/model/client-certificate.model';

type EntityResponseType = HttpResponse<IClientCertificate>;

type EntityArrayResponseType = HttpResponse<IClientCertificate[]>;

@Injectable({ providedIn: 'root' })
export class CertificateMySuffixService {
    private resourceUrl = SERVER_API_URL + 'api/';
    private getfavouriteUrl = SERVER_API_URL + 'api/certificate-requests/favourite';
    private createresourceUrl = SERVER_API_URL + 'api/certificate-client';
    private findResourceUrl = SERVER_API_URL + 'api/certificate-client';
    private certificateRequestUrl = SERVER_API_URL + 'api/certificate-requests';
    private editResourceUrl = SERVER_API_URL + 'api/certificate-client/edit';
    constructor(private http: HttpClient) {}

    create(clientCertificate: IClientCertificate): Observable<EntityResponseType> {
        return this.http.post<IClientCertificate>(this.createresourceUrl, clientCertificate, { observe: 'response' });
    }

    // create(url: any): Observable<any> {
    //     return this.http.post<IClientCertificate>(this.resourceUrl + url, { observe: 'response' }).map((res: any) => res);
    // }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IClientCertificate>(`${this.findResourceUrl}/${id}`, { observe: 'response' });
    }

    findCertificateRequestById(id: number): Observable<any> {
        return this.http.get<any>(`${this.certificateRequestUrl}/${id}`, { observe: 'response' });
    }

    findCertificateRequestForReviseById(id: number,flag:boolean): Observable<any> {
        return this.http.get<any>(`${this.certificateRequestUrl}/${id}/${flag}`, { observe: 'response' });
    }

    // getFavouriteCertificateRequests(): Observable<any> {
    //     return this.http.get<any>(`${this.getfavouriteUrl}`, { observe: 'response' });
    // }


    getFavouriteCertificateRequests(): Observable<any> {
       // const options = createRequestOption(req);
        return this.http
            .get<any[]>(this.getfavouriteUrl, {observe: 'response' })
            .map((res: any) =>res);
    }
    findFavouriteCertificateRequests(data:any,  req?: any): Observable<any> {
         const options = createRequestOption(req);
        return this.http.post<IClientCertificate>(this.getfavouriteUrl, data, { params: options, observe: 'response' });
     }
    editCertificateClient(id: number): Observable<EntityResponseType> {
        return this.http.get<IClientCertificate>(`${this.editResourceUrl}/${id}`, { observe: 'response' });
    }
    deleteCertificateRequestById(id: number): Observable<EntityResponseType> {
        return this.http.delete<any>(`${this.getfavouriteUrl}/${id}`, { observe: 'response' });
    }

    query(url?: any, req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IClientCertificate[]>(this.resourceUrl + url, { params: options, observe: 'response' });
    }

    getById(url?: any, req?: any): Observable<EntityResponseType> {
        //  const options = createRequestOption(req);
        return this.http.get(SERVER_API_URL + url, { observe: 'response' }).map((res: any) => res);
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.findResourceUrl}/${id}`, { observe: 'response' });
    }

    get(url?:string): Observable< HttpResponse<any>> {
        return this.http.get(this.resourceUrl + url, { observe: 'response' }).map((res: any) => res);
    }

    // getInternalClientData(clientId:number): Observable<any>{
    //     return this.http.get<any>(SERVER_API_URL + 'api/certificate-clients/internal-staff/' + clientId, { observe: 'response' });
    //  }
}
